import store from '@/store/index';
import PermissionType from '@/userManagement/PermissionType';
import CheckUtil from './CheckUtil';

export default class PermUtil {
  // eslint-disable-next-line
  public static canCreateOwnPost(): boolean {
    const user = { ...this.currentuser } as any;
    return !!user.roles.find((role: any) => CheckUtil
      .checkPer(role, PermissionType.createOwnPost));
  }

  public static canViewOrgPost(): boolean {
    const user = { ...this.currentuser } as any;
    return !!user.roles.find((role: any) => CheckUtil
      .checkPer(role, PermissionType.canViewOrgPost));
  }
  // eslint-disable-next-line
  public static canDeleteOwnPost(): boolean {
    const user = { ...this.currentuser } as any;
    return !!user.roles.find((role: any) => CheckUtil
      .checkPer(role, PermissionType.deleteOwnPost));
  }
  // eslint-disable-next-line
  public static canCreateCampAdd(): boolean {
    const user = { ...this.currentuser } as any;
    if (this.currentuser === null) {
      return false;
    }
    return !!user.roles.find((role: any) => CheckUtil
      .checkPer(role, PermissionType.createCampAdd));
  }
  // eslint-disable-next-line
  public static canViewSettings(): boolean {
    const user = { ...this.currentuser } as any;
    return !!user.roles.find((role: any) => CheckUtil
      .checkPer(role, PermissionType.canViewSettings));
  }

  public static canViewRoles(): boolean {
    const user = { ...this.currentuser } as any;
    return !!user.roles.find((role: any) => CheckUtil
      .checkPer(role, PermissionType.canViewRoles));
  }

  public static canCreateOrganization(): boolean {
    const user = { ...this.currentuser } as any;
    return !!user.roles.find((role: any) => CheckUtil
      .checkPer(role, PermissionType.canCreateOrganization));
  }

  public static showAdminTab(): boolean {
    const user = { ...this.currentuser } as any;
    if (this.currentuser === null) {
      return false;
    }
    return !!user.roles.find((role: any) => CheckUtil
      .checkPer(role, PermissionType.showAdminTab));
  }

  public static canViewOrganization(): boolean {
    const user = { ...this.currentuser } as any;
    return !!user.roles.find((role: any) => CheckUtil
      .checkPer(role, PermissionType.canViewOrganization));
  }

  // eslint-disable-next-line
  static get currentuser() {
    return store.state.freshCurrentUser;
  }
}
